var map = {
	"./Ck.svg": 6877,
	"./Finance.svg": 95159,
	"./Goods.svg": 31369,
	"./Kc.svg": 7148,
	"./Performance.svg": 23382,
	"./Print.svg": 77131,
	"./Room.svg": 74226,
	"./Setting.svg": 7265,
	"./Staff.svg": 42620,
	"./VIP.svg": 60566,
	"./Wechat.svg": 49949,
	"./dashboard.svg": 58749,
	"./message.svg": 30860
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87886;